import { render, staticRenderFns } from "./Tuzilma.vue?vue&type=template&id=35532a18&scoped=true&"
import script from "./Tuzilma.vue?vue&type=script&lang=js&"
export * from "./Tuzilma.vue?vue&type=script&lang=js&"
import style0 from "./Tuzilma.vue?vue&type=style&index=0&id=35532a18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35532a18",
  null
  
)

export default component.exports